<template>
  <div
    class="jade-spinner"
    :class="computedClassList"
    v-bind="$attrs"
  >
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        role="presentation"
        fill="currentColor"
        clipRule="evenodd"
        d="M10.5 3.24951C9.61358 3.24951 8.73584 3.42411 7.91689 3.76332C7.09794 4.10254 6.35383 4.59975 5.72703 5.22654C5.10023 5.85334 4.60303 6.59745 4.26381 7.4164C3.92459 8.23535 3.75 9.11309 3.75 9.99951C3.75 10.8859 3.92459 11.7637 4.26381 12.5826C4.60303 13.4016 5.10023 14.1457 5.72703 14.7725C6.35382 15.3993 7.09794 15.8965 7.91689 16.2357C8.73583 16.5749 9.61358 16.7495 10.5 16.7495C11.3864 16.7495 12.2642 16.5749 13.0831 16.2357C13.9021 15.8965 14.6462 15.3993 15.273 14.7725C15.8998 14.1457 16.397 13.4016 16.7362 12.5826C17.0754 11.7637 17.25 10.8859 17.25 9.99951C17.25 9.11309 17.0754 8.23535 16.7362 7.4164C16.397 6.59745 15.8998 5.85334 15.273 5.22654C14.6462 4.59975 13.9021 4.10254 13.0831 3.76333C12.2642 3.42411 11.3864 3.24951 10.5 3.24951ZM7.05585 1.6846C8.14778 1.2323 9.3181 0.999512 10.5 0.999512C11.6819 0.999512 12.8522 1.2323 13.9442 1.6846C15.0361 2.13689 16.0282 2.79982 16.864 3.63555C17.6997 4.47128 18.3626 5.46343 18.8149 6.55536C19.2672 7.64729 19.5 8.81762 19.5 9.99951C19.5 11.1814 19.2672 12.3517 18.8149 13.4437C18.3626 14.5356 17.6997 15.5277 16.864 16.3635C16.0282 17.1992 15.0361 17.8621 13.9442 18.3144C12.8522 18.7667 11.6819 18.9995 10.5 18.9995C9.3181 18.9995 8.14778 18.7667 7.05585 18.3144C5.96392 17.8621 4.97177 17.1992 4.13604 16.3635C3.30031 15.5277 2.63738 14.5356 2.18508 13.4437C1.73279 12.3517 1.5 11.1814 1.5 9.99951C1.5 8.81761 1.73279 7.64729 2.18508 6.55536C2.63738 5.46343 3.30031 4.47128 4.13604 3.63555C4.97177 2.79982 5.96392 2.13689 7.05585 1.6846Z"
      />
      <path
        role="presentation"
        fill="currentColor"
        clipRule="evenodd"
        d="M13.0831 3.76333C11.8497 3.25244 10.4925 3.11876 9.18314 3.37921C7.87377 3.63966 6.67104 4.28254 5.72703 5.22654C4.78303 6.17055 4.14015 7.37328 3.8797 8.68265C3.61925 9.99203 3.75293 11.3492 4.26382 12.5826C4.77471 13.816 5.63987 14.8702 6.7499 15.6119C7.85994 16.3536 9.16498 16.7495 10.5 16.7495V18.9995C8.71997 18.9995 6.97991 18.4717 5.49987 17.4827C4.01983 16.4938 2.86628 15.0882 2.18509 13.4437C1.5039 11.7991 1.32567 9.98953 1.67294 8.2437C2.0202 6.49787 2.87737 4.89423 4.13604 3.63555C5.39471 2.37688 6.99836 1.51972 8.74419 1.17245C10.49 0.825181 12.2996 1.00341 13.9442 1.6846C15.5887 2.36579 16.9943 3.51934 17.9832 4.99938C18.9722 6.47942 19.5 8.21948 19.5 9.99951H17.25C17.25 8.66449 16.8541 7.35945 16.1124 6.24942C15.3707 5.13938 14.3165 4.27422 13.0831 3.76333Z"
      />
    </svg>
  </div>
</template>

<script>
import SIZE_ENUM from '../enums/sizes.enum'
import COLOR_ENUM from '../enums/colors.enum'

export default {
  name: 'JadeSpinner',

  props: {
    size: {
      type: String,
      validation: size => Object.values(SIZE_ENUM).includes(size),
      default: SIZE_ENUM.MEDIUM
    },
    color: {
      type: String,
      validation: size => Object.values(COLOR_ENUM).includes(size),
      default: COLOR_ENUM.CURRENT_COLOR
    }
  },

  computed: {
    computedClassList () {
      return {
        [`is-color-${this.color}`]: this.color,
        [`is-${this.size}`]: this.size
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/spinner.css';
</style>
